module.exports = __webpack_public_path__ + "pic/52.78649808.png";